import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
type Props = {
  tone?: 'dark' | 'light';
};
export function Countdown({
  tone = 'dark'
}: Props) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isLight = tone === 'light';
  return <div className={`flex w-full max-w-xl flex-col items-center gap-2 rounded-2xl px-4 py-4 ${isLight ? 'bg-white/10 text-white' : 'bg-navy-800 text-white'}`} role="timer" aria-live="off" data-id="element-21" data-mp="373ufktplzff7">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-sky-400 sm:text-xs" data-id="element-22" data-mp="15an27ptk37vy">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="xytus9m5qp2k" />
        This price expires in
      </p>
      <div className="flex items-end gap-2" data-id="element-24" data-mp="t092qxh27bp7">
        {[{
        value: hours,
        label: 'Hrs'
      }, {
        value: minutes,
        label: 'Min'
      }, {
        value: seconds,
        label: 'Sec'
      }].map((unit, index) => <React.Fragment key={unit.label} data-id="element-25" data-mp="f22i4j14f87h" data-mpi={index}>
            {index > 0 && <span className="pb-5 font-display text-2xl font-black text-sky-400" data-id="element-26" data-mp="f45dlil1ltjl">
                :
              </span>}
            <div className="flex min-w-[64px] flex-col items-center rounded-xl bg-white/10 px-3 py-2 sm:min-w-[76px]" data-id="element-27" data-mp="o38xupvy4ezo">
              <span className="font-display text-3xl font-black tabular-nums sm:text-4xl" data-id="element-28" data-mp="k0m2if02gbxq">
                {pad(unit.value)}
              </span>
              <span className="mt-0.5 text-[10px] font-bold uppercase tracking-widest text-navy-100" data-id="element-29" data-mp="1vgkh0ye0jq6c">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}